import {
	REQUEST_GET_ALL_NOTIFICATIONS,
	RECEIVE_GET_ALL_NOTIFICATIONS,
	RECEIVE_BAD_REQUEST_GET_ALL_NOTIFICATIONS,
	CLEAR_ERROR_NOTIFICATIONS,
	NOTIFICATIONS_PAGE_SHIFT,
	CHANGE_NOTIFICATIONS_FIELD,
	REQUEST_PATCH_NOTIFICATION,
	RECEIVE_PATCH_NOTIFICATION,
	RECEIVE_BAD_REQUEST_PATCH_NOTIFICATION,
	SELECT_ACTIVE_TAB_NOTIFICATION,
	CHANGE_NOTIFICATIONS_STATUS_FILTER,
	CHANGE_NOTIFICATIONS_CASE_TYPE_FILTER,
	RECEIVE_GET_NOTIFICATIONS_INDICATOR,
	REQUEST_GET_NOTIFICATIONS_INDICATOR,
	RECEIVE_FAILURE_GET_NOTIFICATIONS_INDICATOR,
	CLEAR_NOTIFICATIONS_FILTERS,
	GET_NOTIFICATION_TYPES_FAILED, GET_NOTIFICATION_TYPES_SUCCESS, GET_NOTIFICATION_TYPES
} from "./index";
import {actionCreator} from "../helpers/functions";

export const getNotificationTypes = actionCreator(GET_NOTIFICATION_TYPES);

export const getNotificationTypesSuccess = actionCreator(GET_NOTIFICATION_TYPES_SUCCESS);

export const getNotificationTypesFailed = actionCreator(GET_NOTIFICATION_TYPES_FAILED);

export const clearNotificationsFilters = actionCreator(CLEAR_NOTIFICATIONS_FILTERS);

//action that updates visible notifications - depending on case type
export function notificationsCaseTypeFilterChanged (payload) {
	return {
		type: CHANGE_NOTIFICATIONS_CASE_TYPE_FILTER,
		payload
	}
}

//action that updates visible notifications - depending on status
export function notificationsStatusFilterChanged (payload) {
	return {
		type: CHANGE_NOTIFICATIONS_STATUS_FILTER,
		payload
	}
}

//action  that requests to get all notifications
export function requestGetAllNotifications (payload) {
	return {
		type: REQUEST_GET_ALL_NOTIFICATIONS,
		payload
	}
}

//action that receives request to get all notifications
export function receiveGetAllNotifications(response) {
	return {
		type: RECEIVE_GET_ALL_NOTIFICATIONS,
		payload: response
	}
}

//action that receives failed request to get all notifications
export function receiveBadRequestGetAllNotifications(response) {
	return {
		type: RECEIVE_BAD_REQUEST_GET_ALL_NOTIFICATIONS,
		payload: response
	}
}

//action that clears error after notifications get
export function clearErrorNotifications(response) {
	return {
		type: CLEAR_ERROR_NOTIFICATIONS,
		payload: response
	}
}


//action that shifts the page value +-1
export function pageShift(direction, totalPaginationBoxes){
	return {
		type: NOTIFICATIONS_PAGE_SHIFT,
		payload: {
			direction: direction,
			totalPaginationBoxes: totalPaginationBoxes
		}
	}
}

export function changeNotificationsField(key, value) {
	return {
		type: CHANGE_NOTIFICATIONS_FIELD,
		payload: {
			key: key,
			value: value
		}
	}
}

export function selectActiveTabNotification(tab, notificationId, notificationEventName){
	return {
		type: SELECT_ACTIVE_TAB_NOTIFICATION,
		payload: {
			tab,
			notificationId,
            notificationEventName
		}
	}
}

export function requestPatchNotification(key, value, applicationId){
	return {
		type: REQUEST_PATCH_NOTIFICATION,
		payload: {
			key: key,
			value: value,
			applicationId: applicationId
		}
	}
}

export function receivePatchNotification(payload){
	return {
		type: RECEIVE_PATCH_NOTIFICATION,
		payload
	}
}

export function receiveBadRequestPatchNotification(payload){
	return {
		type: RECEIVE_BAD_REQUEST_PATCH_NOTIFICATION,
		payload
	}
}

//NOTIFICATIONS INDICATOR

export function requestNotificationsIndicator(){
	return {
		type: REQUEST_GET_NOTIFICATIONS_INDICATOR,
	}
}

export function receiveNotificationsIndicator(payload){
	return {
		type: RECEIVE_GET_NOTIFICATIONS_INDICATOR,
		payload
	}
}

export function receiveFailureNotificationsIndicator(payload){
	return {
		type: RECEIVE_FAILURE_GET_NOTIFICATIONS_INDICATOR,
		payload
	}
}

